module.exports = __webpack_public_path__ + "static/media/project2.db92410a.png";